import { MEASURE, VOCABO_MEASURE, FORM_MEASURE } from '../../../constants/shared/MeasuresConstants';

const { SPELLING, OL, MAZE } = MEASURE;
const { TQVM, FITB, BD } = VOCABO_MEASURE;
const { SPELLING: SPELLING_FORM_MEASURE } = FORM_MEASURE;

const reformatSpellingFormData = form => ({
    uid: form.form_id,
    measure: SPELLING,
    correctResponses: form.correct_responses,
});

const reformatVocaboFormData = form => ({
    uid: form.form_id,
    questions: form.questions,
    correctResponses: form.correct_responses,
});

const reformatOLFormData = form => ({
    uid: form.form_uid,
    sentences: form.sentences,
});

export const reformatBasicComprehensionFormData = form => ({
    assessment: form.assessment,
    correctResponses: form.correct_responses,
    formUd: form.form_id,
    uid: form.form_id,
    grade: form.grade,
    isRetired: form.is_retired,
    measure: form.measure,
    model: form.model,
    period: form.period,
    practice: form.practice,
    questions: form.questions,
    skillName: form.skill_name,
});

export const parseFormIdsData = formIdsData =>
    formIdsData.map(idObject => ({
        formId: idObject.form_id,
        grade: idObject.grade,
        questionsCount: idObject.total_items.questions,
        sequence: idObject.sequence,
        uid: idObject.uid,
    }));

export const getSharedParserFormByMeasure = form => {
    switch (form.measure) {
        case TQVM:
        case FITB:
        case BD:
            return reformatVocaboFormData(form);
        case SPELLING_FORM_MEASURE:
            return reformatSpellingFormData(form);
        case OL:
            return reformatOLFormData(form);
        case MAZE:
            return reformatBasicComprehensionFormData(form);
        default:
            return form;
    }
};
